import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";

export interface IExactStatus {
	Connected: boolean;
	ExpiresAt?: string;
}

export interface IExactDivision {
	Code: number;
	Description: string;
}

export class ExactServiceClass {
	private readonly baseUrl:string = `${ServerConfig.auth}/auth/exact`;

	async getAuthorizeUrl():Promise<{URL:string, State:string}>{
		let result = await Axios.get(`${this.baseUrl}/authorize-url`);
		return result.data;
	}

	async exchangeCode(code:string):Promise<IExactStatus>{
		let result = await Axios.post(`${this.baseUrl}/exchange-code`, {code});
		return result.data;
	}

	async getStatus():Promise<IExactStatus>{
		let result = await Axios.get(`${this.baseUrl}/status`);
		return result.data;
	}

	async disconnect():Promise<void>{
		await Axios.post(`${this.baseUrl}/disconnect`);
	}

	async getDivisions():Promise<IExactDivision[]>{
		let result = await Axios.get(`${this.baseUrl}/divisions`);
		return result.data || [];
	}

	async getJournals(division:number):Promise<{Code:string, Description:string, Type:number}[]>{
		let result = await Axios.get(`${this.baseUrl}/journals`, {params: {division}});
		return result.data || [];
	}

	async getVATCodes(division:number):Promise<{Code:string, Description:string, Percentage:number}[]>{
		let result = await Axios.get(`${this.baseUrl}/vat-codes`, {params: {division}});
		return result.data || [];
	}

	async getPurchaseVATCodes(division:number):Promise<{Code:string, Description:string, Percentage:number}[]>{
		let result = await Axios.get(`${this.baseUrl}/purchase-vat-codes`, {params: {division}});
		return result.data || [];
	}

	async getItems(division:number, q:string = ""):Promise<{ID:string, Code:string, Description:string}[]>{
		let result = await Axios.get(`${this.baseUrl}/items`, {params: {division, q}});
		return result.data || [];
	}

	async getGLAccounts(division:number, q:string = ""):Promise<{ID:string, Code:string, Description:string, Type:number, BalanceType:string}[]>{
		let result = await Axios.get(`${this.baseUrl}/gl-accounts`, {params: {division, q}});
		return result.data || [];
	}
}

export const ExactService = new ExactServiceClass();
